export const getAirshipChannelId = async (): Promise<string> => {
  let airshipChannelId: string;
  // If the airship script is blocked from download then the promise never resolves. This will bypass that.
  await Promise.race([
    // Use existing channel if browser is already opted in, otherwise create an opted out channel.
    UA.then((sdk) =>
      sdk.channel ?
        sdk.getChannel().then((channel) => (airshipChannelId = channel.channel_id)) :
        sdk.create().then((channel) => (airshipChannelId = channel.channel_id)),
    ).catch((error) => console.log(error)),
    new Promise((resolve) => setTimeout(() => resolve(), 1000)),
  ]);
  return airshipChannelId;
};
